import { render, staticRenderFns } from "./HistoryOld.vue?vue&type=template&id=624ccffa&scoped=true"
import script from "./HistoryOld.vue?vue&type=script&lang=js"
export * from "./HistoryOld.vue?vue&type=script&lang=js"
import style0 from "./HistoryOld.vue?vue&type=style&index=0&id=624ccffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ccffa",
  null
  
)

export default component.exports